"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateUserSettingsRequestDtoContext = void 0;
exports.UpdateUserSettingsRequestDtoContext = {
    Ios: "ios",
    Android: "android",
    WebApp: "web_app",
    ChromeExtension: "chrome_extension",
    EdgeExtension: "edge_extension",
    BrowserExtension: "browser_extension",
    Mac: "mac",
};
